import { render, staticRenderFns } from "./professorTurmas.vue?vue&type=template&id=52a7cb06&scoped=true&"
import script from "./professorTurmas.vue?vue&type=script&lang=js&"
export * from "./professorTurmas.vue?vue&type=script&lang=js&"
import style0 from "./professorTurmas.vue?vue&type=style&index=0&id=52a7cb06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a7cb06",
  null
  
)

export default component.exports